/**
 * useSettingsExpandAll (Jul-2026, User-Wunsch) — reagiert auf das globale
 * „Alles ein-/ausklappen" der Einstellungen (Buttons neben der Universalsuche).
 */
import { useEffect } from "react";

export default function useSettingsExpandAll(setExpanded) {
    useEffect(() => {
        const h = (e) => setExpanded(Boolean(e.detail?.open));
        window.addEventListener("twowheels:settings-expand-all", h);
        return () => window.removeEventListener("twowheels:settings-expand-all", h);
    }, [setExpanded]);
}
